import React from 'react';

import './style.css';

const Box = ({ headTitle, content, leftIcons, iconSize, onClick, renderItem }) => {
	return (
		<div className="Box">
			<div className="Box__title">{headTitle}</div>
			<div className="Box__content">
				{content &&
					content?.length &&
					content?.map(
						item => renderItem && typeof renderItem === 'function' && renderItem(item, { headTitle, content, leftIcons, iconSize, onClick })
					)}
			</div>
		</div>
	);
};
export default Box;
